import { ClientAPI } from 'lib/api';

export const START_GET_CLIENT = 'START_GET_CLIENT';
export const COMPLETE_GET_CLIENT = 'COMPLETE_GET_CLIENT';

export function startGetClient() {
    return {
        type: START_GET_CLIENT,
        startTime: Date.now()
    };
}

export function completeGetClient(client) {
    return {
        type: COMPLETE_GET_CLIENT,
        completeTime: Date.now(),
        client
    };
}

export function fetchClient() {
    return (dispatch) => {
        dispatch(startGetClient());
        return ClientAPI.getClient().then((client) => {
            dispatch(completeGetClient(client || {}));
            return client;
        });
    };
}



// WEBPACK FOOTER //
// ./app/common/actions/clientActions.js